import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface AiReceptionistCallRecordingResponse {
  recording_url: string;
}

interface GetCompanyAiReceptionistCallRecordingPayload {
  company_id: string;
  call_id: string;
}

export async function getCompanyAiReceptionistCallRecording(
  payload: GetCompanyAiReceptionistCallRecordingPayload,
  auth: Authentication,
): Promise<AiReceptionistCallRecordingResponse> {
  try {
    if (!payload.company_id || !payload.call_id) {
      throw new GetCompanyAiReceptionistCallRecordingFailure('company_id et call_id sont requis');
    }

    const response = await HttpClient.post('/company/ai-receptionist/calls/recording', payload, auth.token);

    return response.data as AiReceptionistCallRecordingResponse;
  } catch (e) {
    console.error('getCompanyAiReceptionistCallRecording error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyAiReceptionistCallRecordingFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyAiReceptionistCallRecordingFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyAiReceptionistCallRecordingFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
